module.exports = __webpack_public_path__ + "static/media/busanimation.355a4eaa.riv";